import "./AllCompanies.scss";
import { Fragment } from "react";
import { baseUrl } from "../../../utils/apiData";

const AllCompanies = ({category, title, clients}) => {
  return (
    <section className="all_companies">
      <div className="content_wrap p_top p_bottom">
        <div className="title">
          <p className="t-12 wow fadeInUp">{category}</p>
          <h2 className="wow fadeInUp">
            {title}
          </h2>
        </div>
        
        
        { clients?.length > 0 ? 
        <div className="companies_bigrid">
         {clients?.map((data, j) => {
            return (
              <Fragment key={data._id}>
                <div className="companies_card wow fadeInUp" data-wow-delay={`${(j % 2)*0.1}s`}>
                  <div className="text">
                    <p className="t-16"><b>{data?.name || "-"}</b></p>
                    <p className="t-12">{data?.description || "-"}</p>
                  </div>
                  <div className="img_wrap">
                    <img src={`${baseUrl}/${data?.image}`} alt="logo" />
                  </div>
                </div>
              </Fragment>
            );
          })}
        </div>
        : <p className="text-center pt-5">Data not exist...</p>}
      </div>
    </section>
  );
};

export default AllCompanies;
